import { ref, computed } from '@vue/composition-api';
import interestBehaviorState from './../../store/modules/smart-interests-and-behaviors/index';
import { SMART_INTEREST_SELECTION_HISTORY, SmartInterestType } from '../../const/state/adgroup';
import { trackEvent } from '../../tea-tracker';
import { TRACKING_EVENTS } from './const';

export const useSmartInterestHook = () => {
  const checkBoxStatus = ref(interestBehaviorState.getters.getSmartInterestSelection.value === SmartInterestType.CHECK);
  const showCheckBox = computed(
    () => interestBehaviorState.getters.getEditHistory.value === SMART_INTEREST_SELECTION_HISTORY.EDITED,
  );
  // show checkbox if either 1) Edit icon was clicked. Continue to show after first edit
  const checkBoxHandler = ({ detail }) => {
    trackEvent(detail ? TRACKING_EVENTS.ADD : TRACKING_EVENTS.REMOVE);
    checkBoxStatus.value = detail;
    interestBehaviorState.mutations.setSmartInterestSelection(detail);
  };
  const handleClick = (event: any) => {
    interestBehaviorState.mutations.setSelectionHistory(SMART_INTEREST_SELECTION_HISTORY.EDITED);
  };

  return {
    checkBoxStatus,
    checkBoxHandler,
    handleClick,
    showCheckBox,
  };
};
